import { inputs } from '@ecosystem/newron-design-system';

export const WithSingleSelect = ({ options, value, onChange, label, combobox, ...otherProps }) => {
  const { SingleSelect } = inputs;

  return (
    <div className="retail-insights-select-menu">
      <SingleSelect
        options={options}
        value={value}
        onChange={onChange}
        inlineLabel={label}
        combobox={combobox}
        {...otherProps}
      />
    </div>
  );
};
